export const DEFAULT_ERROR_MESSAGE = "An unexpected error occurred";
export const getErrorFromBackend = (e: unknown): string => {
  const loopbackError = (e as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error?.message || "";
  if (loopbackError) return loopbackError;

  if (e instanceof Error) return e.message;

  return DEFAULT_ERROR_MESSAGE;
};
